import { Slide, TextProps } from '@features/powerpoint';
import { contentSlideHeader } from '../utils';
import { parsedTakeaways } from '../domain/key-takeaways';

const TAKEAWAYS_GROUP_Y_OFFSET = 2.41;

type TakeawaysGroup = {
  label: string;
  takeaways: string[];
};

const takeawaysGroupToTextProps = (
  takeawaysGroup: TakeawaysGroup,
  index: number
): TextProps[] => {
  return [
    {
      text: takeawaysGroup.label,
      options: {
        h: 0.47,
        w: 3.77,
        x: 0.74,
        y: 1.67 + index * TAKEAWAYS_GROUP_Y_OFFSET,
        valign: 'top',
        bold: true,
      },
    },
    {
      text: parsedTakeaways(takeawaysGroup.takeaways),
      options: {
        h: 1.94,
        w: 11.98,
        x: 0.74,
        y: 2.14 + index * TAKEAWAYS_GROUP_Y_OFFSET,
        valign: 'top',
        paraSpaceAfter: 5,
        fontSize: 16,
      },
    },
  ];
};

const takeawaysPresent = (takeaways: string[]): boolean => {
  return takeaways[0] !== '';
};

type ExecutiveSummarySlideProps = {
  slideMaster: string;
  rsaKeyTakeaways: string[];
  ftaKeyTakeaways: string[];
};

export const executiveSummarySlide = (
  props: ExecutiveSummarySlideProps
): Slide => {
  const takeawaysGroups: TakeawaysGroup[] = [
    ...(takeawaysPresent(props.rsaKeyTakeaways)
      ? [
          {
            label: 'Sales Attribution',
            takeaways: props.rsaKeyTakeaways,
          },
        ]
      : []),
    ...(takeawaysPresent(props.ftaKeyTakeaways)
      ? [
          {
            label: 'Visit Attribution',
            takeaways: props.ftaKeyTakeaways,
          },
        ]
      : []),
  ];

  const texts: TextProps[] = [
    contentSlideHeader('Executive Summary'),
    ...takeawaysGroups.flatMap((element, index) =>
      takeawaysGroupToTextProps(element, index)
    ),
  ];

  return {
    slideMaster: props.slideMaster,
    texts,
  };
};
